import { FaInstagram, FaFacebookF, FaTiktok, FaYoutube } from "react-icons/fa";
import { useTranslation } from "../context/TranslationContext";
import Button from "./ds/Button";
import { STATE_LAYER } from "./ds/IconButton";
import Modal from "./ds/Modal";

const SocialMediaLinkingModal = ({
  isOpen,
  setIsOpen,
  setToast,
  isDark,
  onComplete,
  onInstagramVerificationRequest,
}) => {
  const { t } = useTranslation();

  const platforms = [
    { name: "Instagram", icon: FaInstagram, color: "text-pink-500" },
    { name: "TikTok", icon: FaTiktok, color: "text-label-primary" },
    { name: "YouTube", icon: FaYoutube, color: "text-status-danger" },
    { name: "Facebook", icon: FaFacebookF, color: "text-blue-500" },
  ];

  const handlePlatformClick = (platformName) => {
    if (platformName === "Instagram") {
      // Call the callback first to set the flag, then close modal
      if (onInstagramVerificationRequest) {
        onInstagramVerificationRequest("");
      }
      // Don't close modal here - let parent handle it
    } else {
      // For other platforms, show coming soon message
      setToast(t("toasts.platformLinkingComingSoon", { platform: platformName }));
    }
  };

  const handleSkip = () => {
    if (onComplete) {
      onComplete();
    }
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleSkip}
      title={t("socialLinking.title")}
      description={t("socialLinking.intro")}
      closeLabel={t("common.close")}
      isDark={isDark}
    >
      <div className="grid grid-cols-2 gap-space-12">
        {platforms.map((platform) => {
          const PlatformIcon = platform.icon;
          return (
            <button
              key={platform.name}
              type="button"
              onClick={() => handlePlatformClick(platform.name)}
              className={`relative flex flex-col items-center gap-space-8 rounded-radius-md bg-fill-quaternary p-space-16 text-center ${STATE_LAYER}`}
            >
              <PlatformIcon className={`size-6 ${platform.color}`} />
              <span className="text-subheadline-semibold text-label-primary">{platform.name}</span>
              {platform.name === "Instagram" && (
                <span className="text-footnote text-label-secondary">{t("socialLinking.verifyAccount")}</span>
              )}
            </button>
          );
        })}
      </div>
      <div className="flex justify-end">
        <Button variant="gray" onClick={handleSkip}>
          {t("socialLinking.skip")}
        </Button>
      </div>
    </Modal>
  );
};

export default SocialMediaLinkingModal;
